module.exports = __webpack_public_path__ + "static/media/mgo67ws.e0273fcc.pdf";